import { render } from "./EOIDraftConfirmation.vue?vue&type=template&id=2768609a&scoped=true&ts=true&lang=pug"
import script from "./EOIDraftConfirmation.vue?vue&type=script&lang=ts&setup=true"
export * from "./EOIDraftConfirmation.vue?vue&type=script&lang=ts&setup=true"

import "./EOIDraftConfirmation.vue?vue&type=style&index=0&id=2768609a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2768609a"]])

export default __exports__